<template>
  <div class="__wrapper">
    <div class="__head __big" id="scroller" v-show="!showaLert">
      <div class="person-card">
        <img
          v-if="user.profile"
          :src="$fullUrl('images/profiles/' + user.profile)"
        />
        <img v-else src="@/assets/avatar.png" alt />
        <div class="info-text">
          <h2>{{ user.names | validate }}</h2>
          <span>{{ user.job | validate }}</span>
        </div>
      </div>
    </div>
    <div class="__body" v-show="!showaLert">
      <div class="__container">
        <div class="__holder">
          <div class="__section-center">
            <div class="tabs__wrapper">
              <div class="tabs__content">
                <div class="tabs__body">
                  <div class="__section-left">
                    <div class="profile-box __card">
                      <div class="right-box box">
                        <div class="location">
                          {{ user.address | validate }}
                        </div>
                        <div class="__infos" v-if="isAllowed">
                          <span>{{ user.phone | validate }}</span>
                          <span>|</span>
                          <span>{{ user.email | validate }}</span>
                        </div>
                        <div
                          class="cover-letter"
                          v-html="user.description"
                        ></div>
                        <div class="__btn-actions">
                          <span
                            class="view-profile-status"
                            v-if="
                              user.request_view_full_profile_status == 'pending'
                            "
                            >View Full Access is pending
                          </span>
                          <button
                            v-if="
                              user.request_view_full_profile_status ==
                              'rejected'
                            "
                            class="__blued"
                            @click="requestProfile"
                          >
                            View Full Profile
                          </button>
                          <button
                            v-if="
                              user.request_view_full_profile_status == 'allowed'
                            "
                            class="__bluedd"
                            @click="
                              () => {
                                $router.push({
                                  name: 'user-view-profile',
                                  params: { id: user.id },
                                });
                              }
                            "
                          >
                            View Full Profile
                          </button>
                          <button class="__transparent" @click="message">
                            Message
                          </button>
                          <button
                            class="share-btn-transparent"
                            @click="show_share = true"
                          >
                            Share
                          </button>
                        </div>
                        <div class="__availability" v-if="user.available_from">
                          Available from
                          {{ user.available_from | formatDate | validate }}
                        </div>
                      </div>
                    </div>
                    <div class="wrapper-container">
                      <div class="side-2">
                        <!-- Skills widget -->
                        <div class="__card lesss">
                          <div class="__card-wrap">
                            <h2 class="title">Skills</h2>
                            <div class="skills_content__wrapper">
                              <!-- Tools -->
                              <div class="skill_box">
                                <div class="skill_box_header">
                                  <label>Tools</label>
                                </div>
                                <div
                                  class="skill_box_body"
                                  v-if="personalSkills.tools.length > 0"
                                >
                                  <div
                                    class="row__item"
                                    v-for="(
                                      tool, i
                                    ) in personalSkills.tools.slice(0, 5)"
                                    :key="i + 'jksdcka'"
                                  >
                                    <span>{{ tool.name | validate }}</span>
                                    <star-rating
                                      inactive-color="#C1C1C1"
                                      :read-only="true"
                                      active-color="#1BA5A4"
                                      :star-size="14"
                                      :show-rating="false"
                                      v-model="tool.level"
                                    ></star-rating>
                                  </div>
                                </div>
                                <div class="skill_box_body" v-else>
                                  <div class="empty-skills">
                                    <p>
                                      {{ user.first_name | validate }} has not
                                      added any tool yet
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <!-- Competences -->
                              <div class="skill_box">
                                <div class="skill_box_header">
                                  <label>Competences</label>
                                </div>
                                <div
                                  class="skill_box_body"
                                  v-if="personalSkills.competences.length"
                                >
                                  <div
                                    class="row__item"
                                    v-for="(
                                      tool, i
                                    ) in personalSkills.competences.slice(0, 5)"
                                    :key="i + 'dskjank'"
                                  >
                                    <span>{{ tool.name | validate }}</span>
                                    <star-rating
                                      inactive-color="#C1C1C1"
                                      :read-only="true"
                                      active-color="#1BA5A4"
                                      :star-size="14"
                                      :show-rating="false"
                                      v-model="tool.level"
                                    ></star-rating>
                                  </div>
                                </div>
                                <div class="skill_box_body" v-else>
                                  <div class="empty-skills">
                                    <p>
                                      {{ user.first_name | validate }} has not
                                      added any competence yet
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <!-- Roles -->
                              <div class="skill_box">
                                <div class="skill_box_header">
                                  <label>Roles</label>
                                </div>
                                <div
                                  class="skill_box_body"
                                  v-if="personalSkills.roles.length"
                                >
                                  <div
                                    class="row__item"
                                    v-for="(
                                      tool, i
                                    ) in personalSkills.roles.slice(0, 5)"
                                    :key="i + 'sdskja'"
                                  >
                                    <span>{{ tool.name | validate }}</span>
                                    <star-rating
                                      inactive-color="#C1C1C1"
                                      :read-only="true"
                                      active-color="#1BA5A4"
                                      :star-size="14"
                                      :show-rating="false"
                                      v-model="tool.level"
                                    ></star-rating>
                                  </div>
                                </div>
                                <div class="skill_box_body" v-else>
                                  <div class="empty-skills">
                                    <p>
                                      {{ user.first_name | validate }} has not
                                      added any role yet
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="next_skills_content__wrapper">
                              <!-- Domain -->
                              <div class="skill_box">
                                <div class="skill_box_header">
                                  <label>Domains</label>
                                </div>
                                <div
                                  class="skill_box_body"
                                  v-if="personalSkills.domains.length"
                                >
                                  <div
                                    class="row__item"
                                    v-for="(
                                      tool, i
                                    ) in personalSkills.domains.slice(0, 5)"
                                    :key="i + 'skcmkls'"
                                  >
                                    <span>{{ tool.name | validate }}</span>
                                    <star-rating
                                      inactive-color="#C1C1C1"
                                      :read-only="true"
                                      active-color="#1BA5A4"
                                      :star-size="14"
                                      :show-rating="false"
                                      v-model="tool.level"
                                    ></star-rating>
                                  </div>
                                </div>
                                <div class="skill_box_body" v-else>
                                  <div class="empty-skills">
                                    <p>
                                      {{ user.first_name | validate }} has not
                                      added any domain yet
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <!-- Languages -->
                              <div class="skill_box">
                                <div class="skill_box_header">
                                  <label>Languages</label>
                                </div>
                                <div
                                  class="skill_box_body"
                                  v-if="personalSkills.languages.length"
                                >
                                  <div
                                    class="row__item"
                                    v-for="(
                                      tool, i
                                    ) in personalSkills.languages.slice(0, 5)"
                                    :key="i + 'sdjknj'"
                                    v-if="tool.lang"
                                  >
                                    <span>{{ tool.lang.name | validate }}</span>
                                    <star-rating
                                      inactive-color="#C1C1C1"
                                      :read-only="true"
                                      active-color="#1BA5A4"
                                      :star-size="14"
                                      :show-rating="false"
                                      v-model="tool.level"
                                    ></star-rating>
                                  </div>
                                </div>
                                <div class="skill_box_body" v-else>
                                  <div class="empty-skills">
                                    <p>
                                      {{ user.first_name | validate }} has not
                                      added any language yet
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- Project widget -->
                        <div class="__card lesss">
                          <!-- Project item -->
                          <div class="__card-wrap" v-if="projects.length > 0">
                            <h2 class="title">
                              Projects({{ projects.length | validate }})
                            </h2>
                            <div
                              class="__row"
                              :class="{
                                __last: i === projects.slice(0, 2).length - 1,
                              }"
                              v-for="(proj, i) in projects.slice(0, 2)"
                              :key="i"
                            >
                              <div class="group">
                                <img
                                  class="project-brand"
                                  src="@/assets/icons/projects_icon.svg"
                                />
                                <div class="column">
                                  <h3>{{ proj.name | validate }}</h3>
                                  <div v-if="proj.from">
                                    <span
                                      class="date"
                                      style="margin-right: 4px"
                                      >{{
                                        proj.from | formatDate | validate
                                      }}</span
                                    >
                                    <span class="date" v-if="proj.to"
                                      >to
                                      {{
                                        proj.to | formatDate | validate
                                      }}</span
                                    >
                                  </div>
                                  <label>{{
                                    proj.company.name | validate
                                  }}</label>
                                  <label>{{ proj.address | validate }}</label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- Project when empty -->
                          <div class="__card-wrap" v-else>
                            <div class="empty-widget">
                              <div class="empty-widgetheader">
                                <label>Projects</label>
                              </div>
                              <div class="empty-widget-body">
                                <img src="@/assets/icons/projects_icon.svg" />
                                <h1>No Projects</h1>
                                <p>
                                  {{ user.names | validate }} has not added any
                                  project yet.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="__section-right"></div>
        </div>
      </div>
      <div class="floater">
        <chat :stranger="newChat" v-if="access_token"></chat>
      </div>
    </div>
    <div class="modal-question" v-show="showaLert">
      <div class="__body-contents">
        <img src="@/assets/images/logo/new_logo.svg" />
        <p>You need to request for permission to view the full profile.</p>
        <button @click="sendRequest">Request for permission</button>
      </div>
    </div>
    <share-helper
      v-if="show_share"
      @onClose="show_share = false"
      :title="user.names"
      description
    />
  </div>
</template>
<script>
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import { mapGetters } from "vuex";
import { eventBus } from "@/main";
import axios from "axios";
import { API } from "@/Store/variable";
import Chat from "@/components/Chat/Chat";
export default {
  name: "ProfileView",
  components: {
    VueSlider,
    Chat,
  },
  computed: {
    ...mapGetters(["getProfile"]),
    isAllowed() {
      return this.getProfile.isAllowed;
    },
    names() {
      let last_name = "";
      if (this.getProfile.user.last_name) {
        last_name = this.getProfile.user.last_name
          .substring(0, 1)
          .toUpperCase();
      }
      return this.getProfile.user.first_name + " " + last_name;
    },
    id() {
      return this.getProfile.user.id;
    },

    job() {
      let job = {};
      try {
        job = {
          company: this.getProfile.employment[0].company.name,
          role: this.getProfile.employment[0].skills[0].roles[0].name,
          from: this.getProfile.employment[0].from,
          description: this.getProfile.employment[0].description,
        };
        return job;
      } catch (err) {
        return job;
      }
    },
    skills() {
      let skills = {
        tools: [],
        domains: [],
        languages: [],
        competences: [],
        roles: [],
      };
      this.getProfile.skills.forEach((skill) => {
        skills.tools = skills.tools.concat(skill.tools);
        skills.domains = skills.domains.concat(skill.domains);
        skills.languages = skills.languages.concat(skill.languages);
        skills.competences = skills.competences.concat(skill.competences);
        skills.roles = skills.roles.concat(skill.roles);
      });
      return skills;
    },
    location() {
      return this.getProfile.profile.address;
    },
    user() {
      let job = "";
      let country = "";
      let city = "";
      let last_name = "";
      if (this.getProfile.employment.length > 0)
        job = this.getProfile.employment[0].company.name;

      if (this.getProfile.user.last_name) {
        last_name = this.getProfile.user.last_name
          .substring(0, 1)
          .toUpperCase();
      }
      return {
        profile: this.getProfile.user.profile_picture,
        names: this.getProfile.user.first_name + " " + last_name,
        first_name: this.getProfile.user.first_name,
        email: this.getProfile.user.email,
        phone: this.getProfile.profile.phone,
        address: this.getProfile.profile.address,
        request_view_full_profile_status:
          this.getProfile.profile.request_view_full_profile_status,
        job: job,
        available:
          this.getProfile.profile.availability === 1
            ? "Available "
            : this.getProfile.profile.availability === 0
            ? "Not Available From"
            : "",
        available_from: this.getProfile.profile.available_from,
        description: this.getProfile.profile.description,
        id: this.getProfile.user.id,
      };
    },
    projects() {
      let location = { country: {}, city: {}, address: "" };
      if (this.getProfile.projects) {
        return this.getProfile.projects.map(function (item) {
          if (!item.company) eventBus.$set(item, "company", "");

          eventBus.$set(item, "address", item.address);

          eventBus.$set(item, "collapse", true);
          return item;
        });
      } else {
        return [];
      }
    },
    employments() {
      let location = { country: {}, city: {}, address: "", id: 0 };
      if (this.getProfile.employment) {
        return this.getProfile.employment.map(function (item) {
          if (!item.company) eventBus.$set(item, "no company", "");
          eventBus.$set(item, "address", item.address);

          eventBus.$set(item, "collapse", true);
          let role = "no title";
          item.skills.forEach((skill) => {
            skill.roles.forEach((item) => {
              role = item.name;
            });
          });

          eventBus.$set(item, "role", role);

          return item;
        });
      }
    },
    personalSkills() {
      let skills = {
        tools: [],
        domains: [],
        languages: [],
        competences: [],
        roles: [],
      };
      if (this.getProfile.skills) {
        this.getProfile.skills.forEach((skill) => {
          skills.tools = skills.tools.concat(skill.tools);
          skills.roles = skills.roles.concat(skill.roles);
          skills.domains = skills.domains.concat(skill.domains);
          skills.languages = skills.languages.concat(skill.languages);
          skills.competences = skills.competences.concat(skill.competences);
        });
      }
      return skills;
    },
  },
  data() {
    return {
      show_share: false,
      access_token: null,
      newChat: {},
      showaLert: false,
      availability_value: 0,
      colorCache: {},
      options: {
        dotSize: 14,
        width: "50%",
        height: 5,
        railStyle: {
          backgroundColor: "#22B573",
        },
        processStyle: {
          backgroundColor: "#1995A8",
        },
      },
      tabs: {
        isTab1: true,
        isTab2: false,
        isTab3: false,
        isTab4: false,
        isTab5: false,
      },
      tab5: {
        isTab1: true,
        isTab2: false,
        isTab3: false,
      },
      tab3: {
        isTab1: true,
        isTab2: false,
        isTab3: false,
        isTab4: false,
      },
      editProject: false,
      viewProject: true,
      editedProject: {},
      editEmployment: false,
      dialog: false,
      tool: {
        name: "",
        status: true,
      },
      projectSelected: null,
      employmentSelected: null,
      newProject: {
        name: "",
        from: "",
        to: "",
        location: {
          country: "",
          city: "",
          address: "",
        },
        description: "",
        hourly_rate: "",
        tools: [],
        domains: [],
        competences: [],
        roles: [],
        languages: [],
        members: [],
        show: false,
      },
    };
  },
  mounted() {
    let vm = this;
    vm.getStartData();
  },
  methods: {
    getStartData() {
      let vm = this;
      vm.access_token = sessionStorage.authToken;
      if (vm.$route.params.name) {
        let tmp = vm.$route.params.name.split("-");
        let id = window.atob(tmp[tmp.length - 1]);
        vm.$store
          .dispatch("GET_ME_PROFILE", { id: id })
          .then((response) => {})
          .catch((error) => {
            if (response.status == 401) {
              vm.$router.push({
                name: "welcome",
              });
            }
          });
      }
      if (vm.$route.params.id) {
        let id = vm.$route.params.id;
        vm.$store
          .dispatch("GET_ME_PROFILE", { id: id })
          .then((response) => {})
          .catch(({ response }) => {
            if (response.status == 401) {
              vm.$router.push({
                name: "welcome",
              });
            }
          });
      }
    },
    showTab(key) {
      let vm = this;
      Object.keys(this.tabs).forEach(function (key) {
        vm.tabs[key] = false;
      });
      this.tabs[key] = true;
    },
    showSubTab(key) {
      let vm = this;
      Object.keys(this.tabs).forEach(function (key) {
        vm.tab5[key] = false;
      });
      this.tab5[key] = true;
    },
    showSubTab3(key) {
      let vm = this;
      Object.keys(this.tabs).forEach(function (key) {
        vm.tab3[key] = false;
      });
      this.tab3[key] = true;
    },
    editProfile() {
      this.$router.push({ name: "profile-edit", params: { id: this.id } });
    },
    saveProject() {},
    sendRequest() {
      let vm = this;
      vm.showaLert = false;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("REQUEST_TO_VIEW_PROFILE", {
          issuer: vm.id,
          description: "",
          type: "profile-view",
          user: vm.id,
        })
        .then((response) => {
          vm.$store.dispatch("LOADER_CLOSE");
          vm.getStartData();
          vm.$store.dispatch("SET_INFO", {
            state: true,
            message: response.data.message,
            title: "Profile View Request",
          });
        })
        .catch((error) => {
          vm.$store.dispatch("LOADER_CLOSE");
          vm.$store.dispatch("SET_INFO", {
            state: true,
            message: error.response,
            title: "Profile View Request",
          });
          console.log(error.response);
        });
    },
    message() {
      let vm = this;
      if (this.access_token) {
        this.newChat = this.getProfile.user;
      } else {
        vm.$notify({
          group: "status",
          title: "It's important",
          text: "You have to Login or Create account",
          type: "warn",
          duration: 4000,
        });
        this.$router.push({ name: "login" });
      }
      // this.newChat = {}
    },
    requestProfile() {
      let vm = this;
      if (this.access_token) {
        vm.showaLert = true;
      } else {
        vm.$notify({
          group: "status",
          title: "It's important",
          text: "You have to Login or Create account",
          type: "warn",
          duration: 4000,
        });
        this.$router.push({ name: "login" });
      }
    },
  },
  watch: {
    "$route.params.name"(name) {
      let vm = this;
      let tmp = vm.$route.params.name.split("-");
      let id = window.atob(tmp[tmp.length - 1]);
      vm.$store.dispatch("GET_ME_PROFILE", { id: id });
    },
    $route(to, from) {
      this.$store.dispatch("GET_ME_PROFILE", { id: this.$route.params.id });
    },
    "newProject.show": function (val) {
      if (val) {
        (this.editProject = false), (this.viewProject = false);
      }
    },
    editProject: function (val) {
      if (val) {
        (this.newProject.show = false), (this.viewProject = false);
        this.editedProject = this.selectedProject;
      }
    },
    viewProject: function (val) {
      if (val) {
        this.newProject.show = false;
        this.editProject = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets";
button {
  outline: none !important;
}
.__wrapper {
  display: flex;
  box-sizing: border-box !important;
  background: rgba(239, 239, 239, 0.49);
  width: 100%;
  position: relative;
  height: 100%;
  overflow-y: auto;
  flex-direction: column;
  .__head {
    height: 90px;
    position: fixed;
    top: 40px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: url($assets + "/images/backgrounds/wallpaper.svg");
    background-size: cover;
    .person-card {
      display: flex;
      align-self: center;
      margin-top: 20px;
      color: #fff;
      img {
        width: 30px;
        height: 30px;
        border-radius: 100%;
        object-fit: cover;
        margin-top: 15px;
      }
      .info-text {
        margin-left: 10px;
        display: inline-block;
        h2 {
          font-size: 16px;
          font-weight: bolder;
          margin-bottom: 0;
        }
        span {
          font-size: 13px;
        }
      }
    }
  }
  .__big {
    height: 190px;
    position: unset;
    margin-top: 76px;
    .person-card {
      display: flex;
      flex-direction: column;
      align-self: center;
      justify-content: center;
      align-items: center;
      margin-top: 0;
      color: #fff;
      img {
        width: 90px;
        height: 90px;
        border-radius: 100%;
        object-fit: cover;
      }
      .info-text {
        margin-left: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        h2 {
          font-size: 25px;
          text-align: center;
          font-weight: bolder;
          margin-bottom: 0;
        }
        span {
          text-align: center;
          font-size: 17px;
        }
      }
    }
  }
  .__gone {
    display: none;
  }
  .__body {
    background: inherit;
    .section__header {
      width: 100%;
      display: flex;
      flex-direction: column;
      @media (min-width: 300px) and (max-width: 630px) {
        display: none;
      }
      span {
        color: #1890a9;
        align-self: center;
        font-size: 18px;
        font-weight: normal;
        margin-top: 30px;
        margin-bottom: 20px;
      }
      .tabs__wrapper-body {
        display: grid;
        background: #efefef;
        grid-template-columns: 1.5fr 2.5fr 1fr;
        .tab__links {
          padding: 0;
          box-sizing: border-box !important;
          width: 90%;
          height: 50px;
          display: flex;
          justify-content: space-between;
          flex-direction: row;
          span {
            color: #646262;
            cursor: pointer;
            font-weight: normal;
            margin-right: 10px !important;
            opacity: 0.9;
            padding-bottom: 3px;
            margin-top: 20px !important;
            font-size: 14px;
            &:hover {
              color: #1890a9;
              font-weight: normal;
              box-sizing: border-box !important;
            }
          }
          .active_link {
            color: #1890a9;
            border: none !important;
          }
        }
      }
    }
    .__container {
      margin: 0 auto;
      width: 800px;
      min-height: 100%;
      position: relative;
      @media (min-width: 300px) and (max-width: 630px) {
        width: 90%;
      }
      .__holder {
        .__section-center {
          min-width: 0;
          .tabs__wrapper {
            display: flex;
            width: 100%;
            position: relative;
            height: 100%;
            flex-direction: row;
            .tabs__content {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              .tabs__body {
                display: grid;
                position: relative;
                .hamburger_links {
                  position: absolute;
                  display: none;
                  /*display: flex;*/
                  z-index: 9999;
                  left: 0;
                  width: 100%;
                  flex-direction: row;
                  background: rgba(24, 133, 173, 0.8);
                  img {
                    position: relative;
                    top: 0;
                  }
                  .__itemsss {
                    display: flex;
                    flex-direction: column;
                  }
                  img {
                    margin-right: 20px;
                  }
                  span {
                    color: #bebebe;
                    font-size: 12px;
                    text-align: center;
                    padding: 10px;
                    border-bottom: 1px solid rgba(255, 255, 255, 0.6);
                  }
                }
                @media (min-width: 300px) and (max-width: 630px) {
                  grid-template-columns: 1fr;
                }
                .__section-left {
                  position: relative;
                  min-width: 0;
                  /*}*/
                  .zero {
                    padding: 0 !important;
                  }
                  .profile-box {
                    margin-top: 20px;
                    padding-bottom: 0 !important;
                    .right-box {
                      display: flex;
                      flex-direction: column;
                      padding: 20px;
                      justify-content: center;
                      align-items: center;
                      color: #3c4253;
                      font-size: 14px;
                      .cover-letter {
                        margin-top: 10px;
                        text-align: justify;
                        margin-bottom: 20px;
                        p {
                          color: #3c4253;
                          margin-top: 5px;
                          line-height: 21px;
                          font-weight: normal;
                          font-size: 12px;
                        }
                      }
                      img {
                        align-self: flex-end;
                        cursor: pointer;
                      }
                      .__infos {
                        display: flex;
                        line-height: 10px;
                        margin-top: 10px;
                        span {
                          margin-right: 10px;
                          color: #3c4253;
                          font-size: 14px;
                        }
                      }
                      .__btn-actions {
                        display: flex;
                        @media (min-width: 300px) and (max-width: 630px) {
                          flex-direction: column;
                          align-items: center;
                        }
                        .view-profile-status {
                          height: 40px;
                          text-align: center;
                          padding: 0px 15px;
                          width: 180px;
                          font-size: 12px;
                          @media (min-width: 300px) and (max-width: 630px) {
                            margin-bottom: 15px;
                          }
                        }
                        button {
                          outline: none;
                          margin-right: 10px;
                          padding: 0 20px;
                          border-radius: 5px;
                          width: 180px;
                          @media (min-width: 300px) and (max-width: 630px) {
                            margin-bottom: 15px;
                          }
                        }
                        .__blued {
                          outline: none;
                          height: 40px;
                          margin-right: 10px;
                          padding: 0 20px;
                          border-radius: 5px;
                          background: #0884af;
                          color: #fff;
                        }
                        .__bluedd {
                          background: #0e9695 !important;
                          color: #fff;
                        }
                        .__transparent {
                          outline: none;
                          height: 40px;
                          margin-right: 10px;
                          padding: 0 20px;
                          border-radius: 5px;
                          color: #646262;
                          border: 1px solid #dadada;
                        }
                      }
                      .__availability {
                        margin-top: 10px;
                        color: #3c4253;
                        font-size: 14px;
                      }
                    }
                  }
                  .wrapper-container {
                    .profile-box {
                      padding-bottom: 0 !important;
                      margin-bottom: 30px;
                      .right-box {
                        display: flex;
                        flex-direction: column;
                        padding: 20px;
                        justify-content: center;
                        align-items: center;
                        color: #3c4253;
                        font-size: 14px;
                        .cover-letter {
                          p {
                            color: #3c4253;
                            margin-top: 5px;
                            font-weight: normal;
                            font-size: 12px;
                          }
                        }
                        img {
                          align-self: flex-end;
                          cursor: pointer;
                        }
                        .__infos {
                          display: flex;
                          margin-top: 20px;
                          span {
                            margin-right: 10px;
                            color: #3c4253;
                            font-size: 14px;
                          }
                        }
                        .__btn-actions {
                          display: flex;
                          button {
                            outline: none;
                            height: 30px;
                            margin-right: 10px;
                            padding: 0 20px;
                            border-radius: 5px;
                          }
                          .__blued {
                            background: #0884af;
                            color: #fff;
                          }
                          .__transparent {
                            color: #646262;
                          }
                        }
                        .__availability {
                          margin-top: 20px;
                          color: #3c4253;
                          font-size: 14px;
                        }
                      }
                    }
                    .side-2 {
                      min-width: 0;
                      .__card-wrap {
                        padding: 20px;
                        display: flex;
                        flex-direction: column;
                        h2 {
                          color: #000000;
                          margin-bottom: 20px;
                          font-size: 18px !important;
                          font-weight: normal;
                        }
                        .__row {
                          display: flex;
                          width: 100%;
                          justify-content: space-between;
                          padding-bottom: 10px;
                          padding-right: 10px;
                          margin-bottom: 20px;
                          border-radius: 5px;
                          background: #f5f5f5;
                          border: none;
                          padding-top: 10px;
                          padding-left: 10px;
                          .date {
                            color: #6e6e6e;
                            font-size: 12px;
                            font-weight: normal;
                          }
                          .group {
                            display: flex;
                            .project-brand {
                              @media (min-width: 300px) and (max-width: 630px) {
                                display: none;
                              }
                            }
                            img {
                              width: 80px;
                              height: 80px;
                              border-radius: 100%;
                              object-fit: contain;
                              padding: 10px;
                              background: #ebebeb;
                            }
                            .column {
                              display: flex;
                              margin-top: 5px;
                              flex-direction: column;
                              margin-left: 10px;
                              h3 {
                                font-size: 16px;
                                color: #031019;
                                font-weight: normal;
                                margin-bottom: 5px;
                              }
                              label {
                                font-size: 14px;
                                color: #646262;
                                margin: 0 0 5px 0;
                                font-weight: normal;
                              }
                              span {
                                color: #6e6e6e;
                                margin: 0;
                                font-size: 12px;
                              }
                            }
                          }
                        }
                        .__last {
                          border-bottom: none;
                        }
                        .right {
                          align-self: flex-end;
                          font-size: 14px;
                          color: #808080;
                          cursor: pointer;
                          font-weight: normal;
                          &:hover {
                            text-decoration: underline;
                          }
                        }
                        .skills {
                          .boxes,
                          .list {
                            display: flex;
                            justify-content: space-between;
                            margin-bottom: 20px;
                            .item {
                              display: flex;
                              flex-direction: column;
                            }
                            .box,
                            .box-white {
                              width: 90px;
                              min-height: 45px;
                              text-align: center;
                              border-radius: 5px;
                              display: flex;
                              background: #0081b5;
                              color: #fff;
                              flex-direction: column;
                              justify-content: center;
                              align-items: center;
                            }
                            .box-white {
                              background: transparent;
                              color: #646262;
                              border: 0.5px solid #707070;
                              margin-bottom: 10px;
                            }
                          }
                        }
                        .skills_content__wrapper {
                          display: grid;
                          grid-template-columns: 1fr 1fr 1fr;
                          grid-column-gap: 10px;
                          margin-bottom: 10px;
                          @media (min-width: 300px) and (max-width: 630px) {
                            grid-template-columns: 1fr;
                          }
                          .skill_box {
                            min-width: 0;
                            display: flex;
                            flex-direction: column;
                            width: 100%;
                            background: #f5f5f5;
                            border-radius: 5px;
                            margin-bottom: 15px;
                            .skill_box_header {
                              border-bottom: 2px solid #fff;
                              height: 50px;
                              display: flex;
                              align-items: center;
                              justify-content: space-around;
                              padding: 0px 15px;
                              label {
                                color: #0884af;
                                width: 100%;
                                font-size: 15px;
                                font-weight: 800;
                              }
                            }
                            .skill_box_body {
                              padding: 0px 15px;
                              .empty-skills {
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                height: 200px;
                                justify-content: center;
                                p {
                                  text-align: center;
                                  margin-bottom: 20px;
                                  color: #8d8d8d;
                                }
                                button {
                                  width: 133px;
                                  height: 36px;
                                  background: #1890a9 0% 0% no-repeat
                                    padding-box;
                                  border-radius: 5px;
                                  color: #fff;
                                }
                              }
                              .row__item {
                                margin-top: 10px;
                                display: flex;
                                margin-bottom: 10px;
                                justify-content: space-between;
                                width: 100%;
                                span {
                                  color: #000000;
                                  font-weight: normal;
                                  margin-top: 2px;
                                  font-size: 14px;
                                }
                              }
                            }
                          }
                        }
                        .next_skills_content__wrapper {
                          display: grid;
                          grid-template-columns: 1fr 1fr;
                          grid-column-gap: 10px;
                          @media (min-width: 300px) and (max-width: 630px) {
                            grid-template-columns: 1fr;
                          }
                          .skill_box {
                            min-width: 0;
                            display: flex;
                            flex-direction: column;
                            width: 100%;
                            background: #f5f5f5;
                            border-radius: 5px;
                            margin-bottom: 15px;
                            .skill_box_header {
                              border-bottom: 2px solid #fff;
                              height: 50px;
                              display: flex;
                              align-items: center;
                              justify-content: space-around;
                              padding: 0px 15px;
                              label {
                                color: #0884af;
                                width: 100%;
                                font-size: 15px;
                                font-weight: 800;
                              }
                            }
                            .skill_box_body {
                              padding: 0px 15px;
                              .empty-skills {
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                height: 200px;
                                justify-content: center;
                                p {
                                  text-align: center;
                                  margin-bottom: 20px;
                                  color: #8d8d8d;
                                }
                                button {
                                  width: 133px;
                                  height: 36px;
                                  background: #1890a9 0% 0% no-repeat
                                    padding-box;
                                  border-radius: 5px;
                                  color: #fff;
                                }
                              }
                              .row__item {
                                margin-top: 10px;
                                display: flex;
                                margin-bottom: 10px;
                                justify-content: space-between;
                                width: 100%;
                                span {
                                  color: #000000;
                                  font-weight: normal;
                                  margin-top: 2px;
                                  font-size: 14px;
                                }
                              }
                            }
                          }
                        }
                        .empty-widget {
                          .empty-widget-body {
                            height: 350px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            flex-direction: column;
                            p {
                              text-align: center;
                            }
                            h1 {
                              margin-bottom: 30px;
                            }
                            .add-btn {
                              width: 180px;
                              height: 45px;
                              background: #1890a9 0% 0% no-repeat padding-box;
                              border-radius: 4px;
                              color: #fff;
                              outline: none;
                              margin-right: 20px;
                              display: center;
                              justify-content: center;
                            }
                          }
                        }
                      }
                      .__skills-wraper {
                        background: #fff;
                        padding: 20px;
                        border-radius: 5px;
                        width: 100%;
                        .__content-body {
                          overflow: hidden;
                          font-weight: normal;
                          width: 100%;
                          h3 {
                            margin-left: 40px;
                            font-size: 17px;
                            margin-top: 20px;
                            color: #000000;
                            margin-bottom: 20px;
                            font-weight: normal;
                          }
                          .__menus-tab {
                            display: grid;
                            grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
                            background: #f5f5f5;
                            border-radius: 5px;
                            margin: 0 10px;
                            overflow: hidden;
                            span {
                              padding: 12px 0;
                              cursor: pointer;
                              color: #fff;
                              font-size: 15px;
                              text-align: center;
                              background: #c4c4c4;
                              /*&:hover{*/
                              /*background: #FFF;*/
                              /*color: #1BA5A4;*/
                              /*font-weight: normal;*/
                              /*}*/
                            }

                            .activetablink {
                              background: #f5f5f5;
                              color: #1ba5a4;
                              font-weight: bold;
                              border-bottom-left-radius: 5px;
                            }
                          }
                          .__tabs-body {
                            padding: 20px;
                            position: relative;
                            background: #f5f5f5;
                            padding-left: 7%;
                            .__tabs__content {
                              position: relative;
                              top: 0;
                              left: 0;
                              .tabs__content-wrapper {
                                .__headder {
                                  display: flex;
                                  margin-top: 20px;
                                  flex-direction: column;
                                  .icon-texts {
                                    font-size: 17px;
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                    color: #6e6e6e;
                                    padding-right: 10px;
                                    margin-bottom: 20px;
                                    .__row {
                                      display: flex;
                                      flex-direction: row;
                                      justify-content: space-between;
                                      span {
                                        color: #1ba5a4;
                                        cursor: pointer;
                                        margin-right: 10px;
                                        font-size: 15px;
                                      }
                                      .__item {
                                        display: flex;
                                        cursor: pointer;
                                        flex-direction: column;
                                        align-items: center;
                                        justify-content: center;
                                        span {
                                          margin-top: 10px;
                                          font-size: 10px;
                                        }
                                        img {
                                          width: 10px;
                                        }
                                      }
                                    }
                                  }
                                  label {
                                    font-size: 10px;
                                    color: #646262;
                                    font-weight: normal;
                                  }
                                }
                                .__containner {
                                  display: grid;
                                  grid-template-rows: 1fr;
                                  padding-right: 20px;
                                  .__roww {
                                    border-radius: 5px;
                                    display: grid;
                                    grid-template-columns: 2.2fr 1fr 1fr 1fr;
                                    margin-bottom: 5px;
                                    cursor: grab;
                                    background: #fff;
                                    border: 0.5px solid rgba(112, 112, 112, 0.5);
                                    padding: 7px 20px;
                                    justify-content: space-between;
                                    span {
                                      color: #837f7f;
                                      min-width: 0;
                                      text-overflow: ellipsis;
                                      overflow: hidden;
                                      white-space: nowrap;
                                    }
                                    .__actions {
                                      display: flex;
                                      min-width: 0;
                                      justify-content: space-between;
                                      span {
                                        margin-left: 10px;
                                        opacity: 0.4;
                                      }
                                      .__act {
                                        opacity: 1;
                                      }
                                    }
                                    .__actionss {
                                      min-width: 0;
                                      display: flex;
                                      justify-content: center;
                                      align-items: center;
                                      img {
                                        margin-right: 10px;
                                        width: 15px;
                                        height: 15px;
                                        cursor: pointer;
                                      }
                                    }
                                  }
                                  .skill__edit {
                                    display: flex;
                                    flex-direction: column;
                                    padding: 20px;
                                    border-radius: 5px;
                                    margin-bottom: 10px;
                                    background: #efefef;
                                    .__bg-white {
                                      background: #fff;
                                      padding: 7px 10px;
                                      width: 60%;
                                      margin-bottom: 10px;
                                      margin-top: 5px;
                                      outline: none;
                                    }
                                    .check {
                                      width: 60%;
                                      display: flex;
                                      justify-content: space-between;
                                      div {
                                        margin-top: -5px;
                                        input[type="checkbox"] {
                                          background: #fff;
                                          outline: none;
                                          margin-left: 10px;
                                          margin-top: 3px;
                                          padding-left: 5px;
                                          padding-right: 5px;
                                          /*-webkit-appearance:button;*/
                                          color: #fff;
                                          white-space: nowrap;
                                          overflow: hidden;
                                          width: 15px;
                                          height: 15px;
                                          &:checked {
                                            background-color: #000;
                                          }
                                        }
                                      }
                                      .label-check {
                                        margin: -5px 5px 0 5px;
                                      }
                                    }
                                    h5 {
                                      font-size: 15px;
                                      color: #6e6e6e;
                                      margin-bottom: 20px;
                                      font-weight: normal;
                                    }
                                    label {
                                      color: #6e6e6e;
                                      margin-bottom: 0;
                                      font-size: 14px;
                                      margin-left: 10px;
                                      font-weight: normal;
                                    }
                                    .status {
                                      margin-top: 10px;
                                      font-size: 12px;
                                    }
                                    input[type="text"],
                                    select {
                                      background: #fff;
                                      color: #000;
                                      padding: 7px 10px;
                                      width: 60%;
                                      margin-bottom: 10px;
                                      margin-top: 5px;
                                      outline: none;
                                    }
                                    .actions-searchables {
                                      display: flex;
                                      margin-top: 10px;
                                      justify-content: space-between;
                                      .btns {
                                        display: flex;
                                        button {
                                          outline: none;
                                          border: none;
                                          padding: 7px 20px;
                                          border-radius: 5px;
                                          margin-right: 10px;
                                          font-size: 12px;
                                          background: transparent;
                                        }
                                        .__c {
                                          color: #1890a9;
                                          padding: 7px 10px;
                                        }
                                        .__s {
                                          color: #fff;
                                          background: #1890a9;
                                          margin-left: 20px;
                                          font-size: 15px;
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                      .__projects__wrapper {
                        .__right-section {
                          .__center-wrapper {
                            width: 100%;
                            box-sizing: border-box !important;
                            padding: 20px;
                            .__lined {
                              display: flex;
                              justify-content: space-between;
                              margin-bottom: 10px;
                              margin-top: 0;
                              span {
                                color: #1ba5a4;
                                cursor: pointer;
                              }
                              .labell {
                                font-size: 16px;
                                font-weight: normal;
                                color: #000000;
                              }
                            }
                            .project__plane {
                              margin-bottom: 10px;
                              .project__expanded {
                                padding: 20px 20px 10px 20px;
                                .___title {
                                  display: flex;
                                  justify-content: space-between;
                                  .__name-proj {
                                    display: flex;
                                    flex-direction: row;
                                    .__logo {
                                      width: 50px;
                                      margin-right: 10px;
                                      height: 50px;
                                    }
                                    .__name {
                                      display: flex;
                                      text-align: left;
                                      margin-top: 5px;
                                      flex-direction: column;
                                      label {
                                        font-size: 15px !important;
                                        font-weight: normal !important;
                                        color: #000;
                                      }
                                      span {
                                        color: #646262;
                                        margin-left: 0;
                                        margin-top: -3px;
                                        font-weight: normal;
                                        font-size: 16px;
                                      }
                                    }
                                    img {
                                      width: 15px;
                                      margin-left: 10px;
                                      height: 15px;
                                    }
                                    span {
                                      color: #1996a7;
                                      margin-left: 10px;
                                      margin-top: 2px;
                                      font-size: 13px;
                                    }
                                    button {
                                      background: #1ba5a4;
                                      border-radius: 5px;
                                      margin-left: 10px;
                                      outline: none;
                                      color: #fff;
                                      font-weight: normal;
                                      font-size: 14px;
                                      height: 20px !important;
                                      padding: 0 20px !important;
                                      border: none;
                                      cursor: pointer;
                                    }
                                  }
                                  .__icons-project {
                                    span {
                                      margin-right: 10px;
                                      font-size: 14px;
                                      color: #707070;
                                    }
                                    img {
                                      cursor: pointer;
                                      height: 15px;
                                      margin-top: -5px;
                                    }
                                  }
                                }
                                display: flex;
                                flex-direction: column;
                                label {
                                  margin-top: 10px;
                                  margin-bottom: 10px;
                                  font-weight: normal;
                                  color: #646262;
                                  font-size: 14px;
                                }
                                span,
                                p {
                                  font-size: 15px;
                                  color: #000;
                                  font-weight: bold;
                                }
                                .___members {
                                  margin-top: 10px;
                                  margin-bottom: 20px;
                                  display: flex;
                                  img {
                                    width: 30px;
                                    height: 30px;
                                    margin-right: 5px;
                                    border-radius: 100%;
                                  }
                                  .__member-container {
                                    .__member-container-wrapper {
                                      padding: 5px;
                                      background: #1ba5a4;
                                      margin-right: 10px;
                                      position: relative;
                                      border-radius: 16px;
                                      display: flex;
                                      span {
                                        color: #fff;
                                        margin-right: 10px;
                                      }
                                      img {
                                        border-radius: 100%;
                                        width: 22px;
                                        height: 22px;
                                      }
                                      .close {
                                        position: absolute;
                                        right: -5px;
                                        top: -10px;
                                        width: 18px;
                                        height: 18px;
                                        cursor: pointer;
                                      }
                                    }
                                  }
                                }
                                .skills-inner-tab {
                                  .inner-links {
                                    border-radius: 5px;
                                    background: #fff;
                                    display: flex;
                                    overflow: hidden;
                                    justify-content: space-between;
                                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.16);
                                    button {
                                      font-size: 12px;
                                      background: #cccccc;
                                      outline: none;
                                      border: none;
                                      flex: 1;
                                      padding: 10px;
                                      color: #ffffff;
                                    }
                                    .button__active {
                                      background: #fff !important;
                                      color: #1ba5a4;
                                    }
                                  }
                                  .inner-body {
                                    padding-bottom: 20px;
                                    .adding-form {
                                      margin-top: 10px;
                                      padding: 10px;
                                      background: #fff;
                                      margin-bottom: 10px;
                                      display: flex;
                                      border-radius: 5px;
                                      .part {
                                        display: flex;
                                        width: 50%;
                                        flex-grow: 1;
                                        flex-direction: column;
                                        input {
                                          border: none;
                                          border-radius: 5px;
                                          margin-top: 10px;
                                          margin-bottom: 10px;
                                          padding: 7px 10px;
                                          font-weight: normal;
                                          outline: none;
                                          background: #f4f4f4;
                                        }
                                      }
                                    }
                                    .__line {
                                      height: 1px;
                                      width: 100%;
                                      margin: 10px;
                                      background: #707070;
                                    }
                                  }
                                  .list-items {
                                    display: block;
                                    .____item {
                                      padding: 2px 10px;
                                      margin-bottom: 5px;
                                      background: #1ba5a4;
                                      margin-right: 10px;
                                      position: relative;
                                      border-radius: 16px;
                                      display: inline-block;
                                      span {
                                        color: #fff;
                                        margin-right: 10px;
                                      }
                                      .close {
                                        position: absolute;
                                        right: -5px;
                                        top: -10px;
                                        width: 18px;
                                        height: 18px;
                                        cursor: pointer;
                                      }
                                    }
                                  }
                                }
                                .skills_content__wrapper {
                                  display: grid;
                                  grid-template-columns: 1fr 1fr;
                                  grid-gap: 10px;
                                  margin-top: 10px;
                                  .skill_box {
                                    padding: 5px 10px;
                                    min-width: 0;
                                    display: flex;
                                    flex-direction: column;
                                    background: #fff;
                                    border-radius: 5px;
                                    label {
                                      color: #0884af;
                                      width: 100% !important;
                                      padding-bottom: 10px;
                                      font-size: 15px;
                                      border-bottom: 0.4px solid #707070;
                                    }
                                    .row__item {
                                      display: flex;
                                      margin-bottom: 10px;
                                      justify-content: space-between;
                                      width: 100%;
                                      span {
                                        color: #000000;
                                        margin-top: 2px;
                                        font-weight: normal;
                                        font-size: 13px;
                                      }
                                    }
                                  }
                                }
                                .action__expand {
                                  width: 100%;
                                  .__r {
                                    float: right !important;
                                    cursor: pointer;
                                    width: 20px;
                                  }
                                }
                                .__actions {
                                  button {
                                    width: 100px;
                                    outline: none;
                                    border: none;
                                    border-radius: 5px;
                                    padding: 5px;
                                  }
                                  .done {
                                    background: #1885ad;
                                    color: #fff;
                                  }
                                  .cancel {
                                    background: transparent;
                                    color: #1885ad;
                                    margin-left: 10px;
                                  }
                                }
                              }
                              .project__collapsed {
                                padding: 20px 20px 10px 20px;
                                .___title {
                                  display: flex;
                                  justify-content: space-between;
                                  div {
                                    display: flex;
                                    img {
                                      width: 15px;
                                      margin-top: 3px;
                                      height: 15px;
                                      cursor: pointer;
                                      margin-left: 10px;
                                    }
                                    h2 {
                                      font-size: 20px;
                                      color: #031019;
                                      font-weight: normal;
                                    }
                                    span {
                                      color: #6e6e6e;
                                      font-size: 14px;
                                      font-weight: normal;
                                    }
                                  }
                                  img {
                                    width: 25px;
                                    height: 25px;
                                  }
                                }
                                display: flex;
                                flex-direction: column;
                                label {
                                  margin-bottom: 10px;
                                  font-size: 16px;
                                  margin-top: 10px;
                                  font-weight: normal;
                                  color: #646262;
                                }
                                span {
                                  color: #646262;
                                  font-weight: normal;
                                  font-size: 15px;
                                }
                                .action__expand {
                                  width: 100%;
                                  .__r {
                                    float: right !important;
                                    cursor: pointer;
                                    width: 20px;
                                  }
                                }
                              }
                              .__name {
                                position: relative;
                                .floated {
                                  top: -5px;
                                  right: 25px;
                                  margin-left: 0 !important;
                                  width: 10px !important;
                                  height: 10px !important;
                                  position: absolute;
                                }
                              }
                              .ml-20 {
                                margin-left: 20px !important;
                              }
                            }
                            h2 {
                              font-weight: normal;
                              font-size: 20px;
                            }
                            .__row {
                              display: grid;
                              grid-template-columns: 1fr 1fr;
                              grid-column-gap: 10px;
                              .__box {
                                padding: 0 !important;
                                margin: 0 !important;
                                min-width: 100%;
                                .__container {
                                  width: 100%;
                                  margin: 0 !important;
                                  .__row-1 {
                                    display: flex;
                                    width: 100%;
                                    flex-direction: row;
                                    justify-content: space-between;
                                    span {
                                      font-size: 13px;
                                      color: #646262;
                                    }
                                  }
                                  .__name {
                                    color: #837f7f;
                                    margin-top: 10px;
                                    font-size: 12px;
                                  }
                                  .input__dropdown {
                                    position: relative;
                                    padding: 0;
                                    margin-bottom: 10px;
                                    width: 100%;
                                    .dropdown__wrapper {
                                      position: absolute;
                                      left: 0;
                                      width: 100%;
                                      top: 0;
                                      .input {
                                        position: relative;
                                        display: flex;
                                        input {
                                          z-index: 2;
                                          width: 100%;
                                          padding-right: 45px;
                                        }
                                        button {
                                          background: #d9d9d9;
                                          box-shadow: 0 1px 3px
                                            rgba(0, 0, 0, 0.16);
                                          color: #ffffff;
                                        }
                                        .btn-right {
                                          position: absolute;
                                          right: 20px;
                                          cursor: pointer;
                                          top: 6px;
                                          font-size: 6pt;
                                        }
                                      }

                                      .dropdown__body {
                                        background: #f2f2f2 !important;
                                        box-shadow: 0px 0px 5px
                                          rgba(0, 0, 0, 0.4);
                                        border-radius: 4px;
                                        margin-top: -20px;
                                        padding-top: 25px;
                                        width: fit-content;
                                        z-index: 10;
                                        .dropdown__item {
                                          display: flex;
                                          cursor: pointer;
                                          padding: 0px 15px 5px 15px;
                                          margin-top: 10px;
                                          border-bottom: 1px solid #e6e6e6;
                                          flex-direction: row;
                                          img {
                                            width: 19px;
                                            border-radius: 100px;
                                            height: 19px;
                                            margin-right: 8px;
                                          }
                                          .text {
                                            display: flex;
                                            color: #808080;
                                            margin-top: -3px;
                                            font-size: 8pt;
                                            flex-direction: column;
                                            .small {
                                              font-size: 6pt;
                                              font-weight: normal;
                                              margin-top: -2px;
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                            .__description {
                              padding: 10px !important;
                              display: flex;
                              overflow-y: auto;
                              flex-direction: column;
                              .__row-1 {
                                display: flex;
                                width: 100%;
                                margin-bottom: 10px;
                                flex-direction: row;
                                justify-content: space-between;
                                span {
                                  font-size: 10px;
                                }
                                .__resp {
                                  width: 15px;
                                  height: 15px;
                                  cursor: pointer;
                                }
                              }
                              .__desc,
                              textarea,
                              .inpt {
                                height: 120px;
                                background: #fff;
                                resize: none;
                                border-radius: 4px;
                                margin-top: 10px;
                              }
                              span {
                                font-size: 10px;
                              }
                            }
                            .__container {
                              padding: 10px !important;
                              width: 100%;
                              margin: 0 !important;
                              .__row-1 {
                                display: flex;
                                width: 100%;
                                margin-bottom: 10px;
                                flex-direction: row;
                                justify-content: space-between;
                                span {
                                  font-size: 10px;
                                }
                                .__resp {
                                  width: 15px;
                                  height: 15px;
                                  cursor: pointer;
                                }
                              }
                              .__name {
                                color: #837f7f;
                                margin-top: 10px;
                                font-size: 12px;
                              }
                              .__people {
                                margin-top: 10px;
                                display: flex;
                                padding-top: 10px;
                                overflow-x: auto;
                                img {
                                  width: 30px;
                                  height: 30px;
                                  margin-left: 10px;
                                  margin-bottom: 10px;
                                  border-radius: 100px;
                                }
                                .person__item {
                                  position: relative;
                                  width: 40px;
                                  .__close {
                                    background: maroon;
                                    position: absolute;
                                    right: -6px;
                                    cursor: pointer;
                                    top: -6px;
                                    width: 15px;
                                    height: 15px;
                                    border-radius: 100px;
                                    img {
                                      width: 8px;
                                      margin: 0 3px 8px 3px;
                                      height: 8px;
                                    }
                                  }
                                }
                              }
                              .__skills {
                                .__skills-grp {
                                  display: flex;
                                  flex-direction: row;
                                  justify-content: space-between;
                                  .__skills-item {
                                    .__label {
                                      font-size: 16px;
                                      color: #837f7f;
                                      font-weight: normal;
                                    }
                                    .grp {
                                      margin-top: 10px;
                                      .__btn-add {
                                        padding: 1px 10px;
                                        outline: none;
                                        border-radius: 5px;
                                        text-align: center;
                                        cursor: pointer;
                                        color: #fff;
                                        background: #1ba5a4;
                                      }
                                    }
                                    .__tool-name {
                                      display: flex;
                                      background: #cccccc;
                                      padding: 2px 10px;
                                      margin-top: 10px;
                                      flex-direction: row;
                                      .__circled {
                                        width: 7.5px;
                                        margin-top: 3px;
                                        height: 8px;
                                        border-radius: 100px;
                                        border: 0.5px solid #1ba5a4;
                                      }
                                      img {
                                        width: 7.5px;
                                        margin-top: 3px;
                                        height: 8px;
                                        cursor: pointer;
                                      }
                                      span {
                                        color: #979797;
                                        font-weight: normal;
                                        margin-left: 5px;
                                        font-size: 10px;
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                          .form {
                            span {
                              font-size: 14px;
                              margin-left: 10px;
                              margin-bottom: 10px;
                              color: #646262;
                            }
                            .__row {
                              display: flex;
                              justify-content: space-between;
                              h2 {
                                color: #000000;
                                font-size: 15px;
                                margin-bottom: 20px;
                                font-weight: normal;
                              }
                              button {
                                background: transparent;
                                outline: none;
                                color: #680404;
                                width: 118px;
                                border-radius: 5px;
                                border: 0.5px solid #7e0505;
                                height: 27px;
                                img {
                                  margin-left: 10px;
                                }
                              }
                            }

                            .form-group {
                              display: flex;
                              justify-content: space-between;
                              .__box {
                                max-width: 50%;
                                width: 50%;
                                display: flex;
                                flex-direction: column;
                                span {
                                  font-size: 14px;
                                  margin-left: 10px;
                                  margin-bottom: 10px;
                                  color: #646262;
                                }
                                .grouped,
                                input[type="text"],
                                textarea,
                                select {
                                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
                                  background: #fff;
                                  font-size: 14px;
                                  resize: none;
                                  display: flex;
                                  margin-bottom: 20px;
                                  justify-content: space-between;
                                  width: 100%;
                                  padding: 10px;
                                  outline: none;
                                  border-radius: 5px;
                                  border: none;
                                  color: #707070;
                                  .__date-field {
                                    background-color: #f4f4f4;
                                    background-image: url($assets + "/icons/calendar__icon.svg");
                                    background-repeat: no-repeat;
                                    background-position: right;
                                    width: 49%;
                                    padding: 5px;
                                  }
                                }
                                .grouped {
                                  padding: 5px 10px;
                                }
                                textarea {
                                  height: 100px !important;
                                }
                              }
                            }
                            .__box {
                              max-width: 100%;
                              width: 100%;
                              display: flex;
                              flex-direction: column;
                              span {
                                font-size: 13px;
                                color: #646262;
                                margin-left: 10px;
                              }
                              .grouped,
                              input[type="text"],
                              textarea,
                              select {
                                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
                                background: #fff;
                                font-size: 13px;
                                resize: none;
                                display: flex;
                                margin-bottom: 20px;
                                justify-content: space-between;
                                width: 100%;
                                padding: 10px;
                                outline: none;
                                border-radius: 5px;
                                border: none;
                                color: #707070;
                                .__date-field {
                                  background: #f4f4f4;
                                  width: 49%;
                                  padding: 5px;
                                }
                              }
                              textarea {
                                height: 100px !important;
                              }
                            }
                          }
                        }
                      }
                      .__qualifications__wrapper {
                        background: #fff;
                        padding: 0;
                        border-radius: 5px;
                        width: 100%;
                        .__content-body {
                          overflow: hidden;
                          font-weight: normal;
                          width: 100%;
                          margin-top: 20px;
                          padding: 20px;
                          h3 {
                            padding-left: 10px;
                            margin-bottom: 0;
                            padding-bottom: 20px;
                            font-weight: normal !important;
                            color: #6e6e6e;
                            font-size: 17px;
                          }
                          .__menus-tab {
                            display: grid;
                            grid-template-columns: 1fr 1fr 1fr;
                            background: #fff;
                            border-radius: 5px;
                            margin: 0;
                            overflow: hidden;
                            span {
                              padding: 12px 0;
                              cursor: pointer;
                              color: #fff;
                              font-size: 15px;
                              text-align: center;
                              background: #c4c4c4;
                              /*&:hover{*/
                              /*background: #FFF;*/
                              /*color: #1BA5A4;*/
                              /*font-weight: normal;*/
                              /*}*/
                            }
                            .__lefty {
                              padding-left: 10px;
                              text-align: left !important;
                            }
                            .activetablink {
                              background: #f5f5f5;
                              color: #1ba5a4;
                              font-weight: bold;
                              border-bottom-left-radius: 5px;
                            }
                          }
                          .__tabs-body {
                            position: relative;
                            .__tabs__content {
                              position: relative;
                              top: 0;
                              left: 0;
                              .tabs__content-wrapper {
                                display: flex;
                                flex-direction: column;
                                .title__actions {
                                  display: flex;
                                  padding-top: 40px !important;
                                  justify-content: space-between;
                                  h2 {
                                    font-size: 17px;
                                    color: #6e6e6e;
                                    margin-top: 3px;
                                    margin-left: 10px;
                                    margin-bottom: 0 !important;
                                    font-weight: normal;
                                  }
                                  div {
                                    align-self: flex-end;
                                    span {
                                      font-size: 14px;
                                      cursor: pointer;
                                      margin-right: 5px;
                                    }
                                    img {
                                      cursor: pointer;
                                      width: 12px;
                                    }
                                  }
                                }
                                .__item-row {
                                  display: flex;
                                  width: 100%;
                                  flex-direction: column;
                                  /*border-bottkom: 0.5px solid rgba(112,112,112,0.2);*/
                                  .__collapsed,
                                  .__expanded {
                                    display: flex;
                                    padding: 10px;
                                    margin-bottom: 10px;
                                    flex-direction: column;
                                    .__title {
                                      font-size: 14px;
                                      color: #6e6e6e;
                                      font-weight: normal;
                                      margin-top: 10px;
                                      margin-bottom: 10px;
                                    }
                                    .__normal {
                                      font-size: 13px;
                                      color: #000;
                                      font-weight: normal;
                                      margin-bottom: 10px;
                                    }
                                    .__darked {
                                      color: #000;
                                      font-weight: normal;
                                      margin-top: 10px;
                                      font-size: 18px;
                                    }
                                    .__light {
                                      color: #646262;
                                      margin-top: 10px;
                                      font-weight: normal;
                                      font-size: 14px;
                                    }
                                    .__action {
                                      align-self: flex-end;
                                      font-size: 10px;
                                      cursor: pointer;
                                    }
                                    .logo {
                                      display: flex;
                                      margin-bottom: 20px;
                                      flex-direction: column;
                                      img {
                                        width: 100px;
                                        height: 100px;
                                      }
                                      label {
                                        margin-top: 10px;
                                        font-size: 18px;
                                        font-weight: normal;
                                        color: #000000;
                                      }
                                    }
                                  }

                                  .__titlee {
                                    background: transparent;
                                    padding: 5px 10px;
                                    display: flex;
                                    color: #fff;
                                    flex-direction: row;
                                    justify-content: space-between;
                                    .__rowed {
                                      display: flex;
                                      flex-direction: row;
                                      width: 100%;
                                      justify-content: space-between;
                                      img {
                                        width: 15px;
                                        margin-left: 10px;
                                        height: 15px;
                                      }
                                      span {
                                        font-size: 14px;
                                        font-weight: bold;
                                        margin-left: 10px;
                                      }
                                    }
                                  }
                                }
                                .__value {
                                  color: #837f7f;
                                  margin-top: 5px;
                                }
                                .__description {
                                  display: flex;
                                  width: 60%;
                                  padding: 10px;
                                  border-radius: 4px;
                                  height: 100px;
                                  border: 0.4px solid rgba(112, 112, 112, 0.3);
                                  margin-top: 20px;
                                  flex-direction: row;
                                  justify-content: space-between;
                                  .__contents {
                                    display: flex;
                                    flex-direction: column;
                                  }
                                }
                                .__bodyy {
                                  background: #fff;
                                  border-radius: 5px;
                                  padding: 30px 5px 10px 5px;
                                  .__itemm {
                                    display: flex;
                                    width: 100%;
                                    overflow: hidden;
                                    border-radius: 5px;
                                    background: #ffffff;
                                    flex-direction: column;
                                    .__boxx {
                                      display: flex;
                                      width: 100%;
                                      border-top: 1px solid #ececec;
                                      border-bottom: 1px solid #ececec;
                                      margin-right: 10px;
                                      padding: 7px 10px;
                                      flex-direction: row;
                                      span {
                                        margin-left: 10%;
                                        flex-grow: 1;
                                        margin-top: 5px;
                                        font-size: 11px;
                                        color: #131313;
                                      }
                                      img {
                                        cursor: pointer;
                                        margin-top: -5px;
                                        /*width: 20px;*/
                                        /*height: 20px;*/
                                      }
                                      .avatar {
                                        background: #1890a9;
                                        width: 30px;
                                        height: 30px;
                                        color: #fff;
                                        align-items: center;
                                        display: flex;
                                        justify-content: center;
                                        font-size: 11px;
                                        border-radius: 100%;
                                        font-weight: bold;
                                      }
                                      .date {
                                        font-size: 11px;
                                        color: #131313;
                                        margin-top: 5px;
                                        margin-right: 20px;
                                        font-weight: normal;
                                      }
                                    }
                                    p {
                                      font-size: 10px;
                                      margin-top: 10px;
                                      color: #034057;
                                    }
                                  }
                                }
                                .form-add {
                                  display: flex;
                                  flex-direction: column;
                                  padding-right: 20px;
                                  padding-left: 20px;
                                  .__row {
                                    display: flex;
                                  }
                                  .__title {
                                    font-size: 21px;
                                    margin-top: 10px;
                                    color: #1ba5a4;
                                    font-weight: normal;
                                  }
                                  span {
                                    color: #000;
                                    font-size: 13px;
                                    margin-top: 30px;
                                  }
                                  h2 {
                                    font-size: 14px;
                                    font-weight: normal;
                                    margin-top: 20px;
                                  }
                                  label {
                                    font-size: 14px;
                                    color: #676767;
                                    margin-top: 20px;
                                    font-weight: normal;
                                  }
                                  .top {
                                    margin-top: 10px;
                                  }
                                  .__colored {
                                    color: #1885ad !important;
                                    margin-top: 20px;
                                  }
                                  input,
                                  textarea,
                                  .input,
                                  select {
                                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
                                    background: #fff;
                                    font-size: 12px;
                                    resize: none;
                                    display: flex;
                                    justify-content: space-between;
                                    width: 100%;
                                    padding: 10px !important;
                                    outline: none;
                                    border-radius: 5px;
                                    border: none;
                                    color: #707070;
                                  }
                                  input,
                                  .input,
                                  select {
                                    padding: 10px !important;
                                  }
                                  select {
                                    width: 100%;
                                  }
                                  textarea {
                                    min-height: 80px;
                                    padding: 10px;
                                  }
                                  .__save {
                                    display: flex;
                                    margin-top: 20px;
                                    button {
                                      background: #1885ad;
                                      border: 0.21px solid #666666;
                                      border-radius: 5px;
                                      color: #fff;
                                      padding: 7px 35px;
                                      box-shadow: 0 4px 4px rgba(0, 0, 0, 0.16);
                                    }
                                    .__none {
                                      background: none;
                                      border: none;
                                      box-shadow: none;
                                      margin-left: 10px;
                                      color: #1ba5a4;
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
                .__section-right {
                  display: flex;
                  min-width: 0;
                  flex-direction: column;
                  .__leads {
                    display: inherit;
                    width: 100%;
                    .__lead-container {
                      width: 100%;
                      .__card {
                        margin-bottom: 10px;
                        // box-shadow: 0 2px 1px rgba(0,0,0,0.16);
                      }
                      h2 {
                        font-weight: normal;
                        font-size: 20px;
                      }
                      .__row {
                        display: flex;
                        padding: 10px;
                        img {
                          width: 30px;
                        }
                        .column {
                          display: flex;
                          flex-direction: column;
                          margin-left: 10px;
                          h3 {
                            font-size: 12px;
                            font-weight: normal;
                            margin-bottom: 0;
                          }
                          label {
                            font-size: 11px;
                            margin: 0;
                            font-weight: normal;
                          }
                          span {
                            color: #6e6e6e;
                            margin: 0;
                            font-size: 11px;
                          }
                        }
                      }
                      .right {
                        align-self: flex-end;
                        cursor: pointer;
                        &:hover {
                          text-decoration: underline;
                        }
                      }
                    }
                  }
                  .__tags {
                    h1 {
                      color: #1885ad;
                      font-size: 24px;
                    }
                    .__card {
                      .__tags__wrapper {
                        display: flex;
                        padding: 20px;
                        padding-top: 10px;
                        flex-direction: column;
                        h2 {
                          color: #1890a9;
                          font-size: 16px;
                          font-weight: normal;
                        }
                        span {
                          font-size: 12px;
                          color: #6e6e6e;
                          margin-top: 10px;
                          font-weight: normal;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        .__section-right {
          position: relative;
          min-width: 0;
          padding-top: 10px;
          @media (min-width: 300px) and (max-width: 630px) {
            top: 20px;
          }
          display: flex;
          flex-direction: column;
          h2 {
            font-size: 15px;
            color: #535353;
          }
          .__suggestion-box {
            padding: 10px;
            background: #ffffff;
            box-shadow: 0 4px 4px rgba(0, 0, 0, 0.16);
            margin-bottom: 20px;
            border-radius: 5px;
            /*.__title{*/
            /*padding: 10px;*/
            /*color: #808080;*/
            /*border-bottom: 0.7px solid rgba(112,112,112,0.4);*/
            /*}*/
            .__body {
              margin-top: 0px;
              background: transparent;
              .__item {
                display: flex;
                margin-bottom: 20px;
                flex-direction: row;
                img,
                .__logo {
                  width: 25px;
                  height: 25px;
                  border-radius: 100%;
                }
                .__logo {
                  background: #1885ad;
                  padding: 0 !important;
                  box-sizing: border-box;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  span {
                    color: #fff;
                    font-size: 42px;
                    margin: 0 0 12px 12px;
                    font-weight: normal;
                  }
                }
                .__centered {
                  display: flex;
                  flex-direction: row;
                  width: 100%;
                  margin-left: 10px;
                  justify-content: space-between;
                  .__text {
                    display: flex;
                    flex-direction: column;
                    h3 {
                      margin-bottom: 0;
                      font-weight: normal;
                      font-size: 13px;
                      cursor: pointer;
                    }
                    span {
                      margin-top: -5px;
                      font-size: 10px;
                    }
                    .__greyed {
                      color: #000;
                      cursor: default;
                    }
                    label {
                      font-size: 11px;
                    }
                  }
                  img {
                    padding: 5px;
                    border-radius: 100px;
                    width: 20px;
                    height: 20px;
                    background: #ececef;
                  }
                }
              }
              .vertical {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                span {
                  color: #959595;
                  font-size: 10px;
                  margin-bottom: 10px;
                  font-weight: normal;
                }
                h1 {
                  color: #959595;
                  font-size: 19px;
                  opacity: 0.6;
                  font-weight: normal;
                }
                label {
                  font-size: 11px;
                  font-weight: normal;
                  margin-top: 30px;
                  color: #959595;
                }
                img {
                  margin-top: 30px;
                }
              }
            }
          }
          .__feed-box {
            padding: 10px;
            margin-top: 10px;
            background: #ffffff;
            box-shadow: 0 4px 4px rgba(0, 0, 0, 0.16);
            border-radius: 5px;
            .__title {
              padding: 10px 10px 0 10px;
              color: #808080;
              font-size: 20px;
              border-bottom: 0.7px solid rgba(112, 112, 112, 0.4);
            }
            .__body {
              margin-top: 20px;
              background: transparent;
              .__item {
                display: flex;
                margin-bottom: 20px;
                flex-direction: column;
                .__title,
                .__contents {
                  display: flex;
                  justify-content: space-around;
                  border: none;
                  flex-direction: row;
                  .__green {
                    font-size: 12px;
                    cursor: pointer;
                  }
                  span {
                    font-size: 12px;
                  }
                  img {
                    margin-right: 10px;
                    width: 40px;
                    height: 40px;
                  }
                }
              }
            }
          }
          .__chat {
            padding: 0 10px 10px 10px;
            height: 40px;
            background: #fafafa;
            box-shadow: 0 3px 4px rgba(0, 0, 0, 0.16);
            border: 0.5px solid rgba(112, 112, 112, 0.4);
            border-top-left-radius: 13px;
            border-top-right-radius: 13px;
            position: fixed;
            bottom: 0;
            .__title {
              padding: 10px;
              cursor: pointer;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              color: #00a99d;
              border: none;
            }
            .__input {
              margin-top: 10px;
              width: 220px;
              margin-bottom: 20px;
              input {
                background: url($assets + "/icons/search.svg") right;
                background-size: 15px;
                outline: none;
                padding: 3px 5px 3px 10px;
                width: 100%;
                color: #999999;
                border: 0.7px solid rgba(112, 112, 112, 0.4);
                background-repeat: no-repeat;
                background-origin: content-box;
                &::placeholder {
                  color: #999999;
                }
                &::-webkit-input-placeholder {
                  /* Chrome/Opera/Safari */
                  color: #999999;
                }
                &::-moz-placeholder {
                  /* Firefox 19+ */
                  color: #999999;
                }
                &:-ms-input-placeholder {
                  /* IE 10+ */
                  color: #999999;
                }
                &:-moz-placeholder {
                  /* Firefox 18- */
                  color: #999999;
                }
              }
            }
            .__body {
              background: transparent;
              height: 190px;
              cursor: pointer;
              overflow-y: auto !important;
              &::-webkit-scrollbar {
                background-color: transparent;
                width: 12px;
              }

              &::-webkit-scrollbar-track {
                background-color: transparent;
              }

              /* scrollbar itself */
              &::-webkit-scrollbar-thumb {
                background-color: #babac0;
                border-radius: 16px;
                border: 4px solid #f2f2f2;
              }
              &::-webkit-scrollbar-button {
                display: none;
              }
              .__item-chat {
                display: flex;
                background: transparent;
                flex-direction: row;
                cursor: pointer;
                padding: 10px 0;
                border-bottom: 0.7px solid rgba(112, 112, 112, 0.4);
                img {
                  width: 35px;
                  border-radius: 100px;
                  height: 35px;
                }
                .__text {
                  display: flex;
                  text-align: left;
                  flex-direction: column;
                  margin-left: 10px;
                  .__tite {
                    text-align: left;
                    font-size: 14px;
                    font-weight: normal;
                    color: #666666;
                  }
                  ._2 {
                    color: #999999;
                    font-weight: normal;
                    font-size: 11px;
                    margin-top: -5px;
                  }
                }
              }
            }
          }
          .__chat-list {
            position: fixed;
            bottom: 0;
            right: 28%;
            display: flex;
            flex-direction: row-reverse;
            .__chat-individual {
              margin-right: 10px;
              height: 300px;
              background: #fafafa;
              box-shadow: 0 3px 4px rgba(0, 0, 0, 0.16);
              border: 0.5px solid rgba(112, 112, 112, 0.4);
              border-top-left-radius: 13px;
              border-top-right-radius: 13px;
              .__title {
                padding: 10px;
                cursor: pointer;
                width: 220px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                color: #00a99d;
                border: none;
                .__chat-header {
                  img {
                    border-radius: 100px;
                    width: 15px;
                    margin-right: 5px;
                    height: 15px;
                  }
                }
                img {
                  width: 20px;
                  height: 20px;
                }
              }
              .__body {
                background: #e6e6e6;
                height: 190px;
                padding-left: 10px;
                cursor: pointer;
                overflow-y: auto !important;
                &::-webkit-scrollbar {
                  background-color: transparent;
                  width: 12px;
                }

                &::-webkit-scrollbar-track {
                  background-color: transparent;
                }

                /* scrollbar itself */
                &::-webkit-scrollbar-thumb {
                  background-color: #babac0;
                  border-radius: 16px;
                  border: 4px solid #f2f2f2;
                }
                &::-webkit-scrollbar-button {
                  display: none;
                }
                .__item-chat {
                  display: flex;
                  background: transparent;
                  flex-direction: column;
                  cursor: pointer;
                  padding: 10px 0;
                  img {
                    width: 35px;
                    border-radius: 100px;
                    height: 35px;
                  }
                  .__text {
                    display: flex;
                    text-align: left;
                    background: url($assets + "/images/backgrounds/chat_bg-left.svg")
                      no-repeat;
                    background-size: contain;
                    padding: 5px 10px;
                    flex-direction: column;
                    margin-left: 10px;
                    span {
                      text-align: left;
                      font-size: 12px;
                      font-weight: normal;
                      color: #ffffff;
                    }
                  }
                  .__me {
                    align-self: flex-end;
                    background: url($assets + "/images/backgrounds/chat__bg-right.svg")
                      no-repeat;
                    span {
                      color: #00a99d;
                    }
                  }
                }
              }
              .chat_typing-input {
                position: fixed;
                bottom: 0;
                width: 220px;
                padding: 0 5px;
                height: 65px;
                background: #fafafa;
                .__input-container {
                  display: flex;
                  justify-content: space-between;
                  textarea {
                    font-size: 12px;
                    opacity: 0.8;
                    width: 80%;
                    outline: none;
                    font-weight: normal;
                    &:hover {
                      outline: none;
                    }
                  }
                  img {
                    cursor: pointer;
                    width: 20px;
                    height: 20px;
                  }
                }
                .__actions {
                  display: flex;
                  position: absolute;
                  width: 100px;
                  justify-content: space-between;
                  bottom: 10px;
                  flex-direction: row;
                  .btn-post {
                    background: #1885ad;
                    padding-left: 20px;
                    color: #ffffff;
                    font-size: 12px;
                    font-weight: normal;
                    padding-right: 20px;
                    padding-top: 2px;
                    border-radius: 2px;
                    cursor: pointer;
                  }
                  .__icon {
                    width: 20px;
                    height: 20px;
                    img {
                      width: 15px;
                      cursor: pointer;
                      height: 15px;
                    }
                  }
                }
              }
            }
          }
          .__collapse {
            height: 300px;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            padding: 10px;
          }
        }
      }
    }
    .__menus {
      display: none;
      @media (min-width: 300px) and (max-width: 630px) {
        display: grid;
        width: 100%;
        background: #f5f9fc !important;
        position: fixed;
        bottom: 0;
        grid-template-columns: 1fr 1fr 1fr;
        grid-column-gap: 1px;
      }
      span {
        padding: 10px;
        text-align: center;
        color: #1885ad;
      }
      .__activee {
        background: #1885ad;
        color: #fff;
      }
    }
  }
  .modal-question {
    position: absolute;
    top: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #ffffff;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.16);
    border-radius: 5px;
    padding: 20px 50px;
    border: 0.5px rgba(112, 112, 112, 0.9);
    .__body-contents {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      p {
        color: #808080;
        font-size: 18px;
        margin: 20px 0;
      }
      button {
        width: 284px;
        height: 36px;
        border-radius: 18px;
        margin: 20px 0;
        color: #fff;
        background-image: linear-gradient(267deg, #1885ad, #00a3a8);
      }
    }
  }
}
.__blued {
  outline: none;
  margin-right: 10px;
  padding: 0 20px;
  border-radius: 5px;
  background: #1ba5a4;
  color: #fff;
}
.__transparent {
  outline: none;
  margin-right: 10px;
  padding: 0 20px;
  border-radius: 5px;
  color: #646262;
}
.share-btn-transparent {
  outline: none;
  height: 40px;
  margin-right: 10px;
  padding: 0 20px;
  border-radius: 5px;
  color: #646262;
  border: 1px solid #dadada;
}
.__card {
  background: #fff;
  border-radius: 5px;
  margin-bottom: 10px;
  // box-shadow: 0 1px 3px rgba(0,0,0,0.16);
}
.floater {
  position: fixed;
  bottom: 0px;
  z-index: 99999;
  right: 10px;
}
</style>
